<template>
    <listHappinessTipsCategoriesComponent />
</template>

<script>
import listHappinessTipsCategoriesComponent from "@/views/happiness-tips/pages/list_happiness-tips-categories/components/list_happiness_tips_categories_component.vue";
export default {
    name: "listHappinessTipsCategoriesPage",
    components: {
        listHappinessTipsCategoriesComponent
    },
}
</script>

<style lang="css" scoped>
</style>
